/**
 * @generated SignedSource<<5f83a0f45e6d6c802b750d942828fd46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PictureBlock_contentBlock$data = {
  readonly altText: string;
  readonly title: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "PictureBlock_contentBlock";
};
export type PictureBlock_contentBlock$key = {
  readonly " $data"?: PictureBlock_contentBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"PictureBlock_contentBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PictureBlock_contentBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "altText",
      "storageKey": null
    }
  ],
  "type": "PictureBlock",
  "abstractKey": null
};

(node as any).hash = "1a13daa9cf36142ea3eb2f59b759804e";

export default node;
